export default "__VITE_ASSET__ca930b38__"